/* eslint-disable prefer-arrow-callback, func-names, prefer-arrow-callback, func-names, no-use-before-define, prefer-arrow-callback, func-names, no-use-before-define, prefer-const, object-shorthand, prefer-const, prefer-arrow-callback, func-names, no-param-reassign */
// Only run if window.did exists and the block is present and enabled
document.addEventListener('DOMContentLoaded', function () {
    // Look for the button block with the data attribute set (adjust selector as needed)
    const chaseButton = document.querySelector(
        '[data-enable-chase-oauth-link="true"]',
    );
    if (!window.did || !chaseButton) return; // Exit if block/feature not present

    window.did.on('init', async function (guest) {
        await updateChaseLinks(guest.guest);
    });

    window.did.on('login', async function (guest) {
        await updateChaseLinks(guest);
    });

    async function updateChaseLinks(guest) {
        const accessToken = guest?.token?.access_token;
        let url = '#';

        if (accessToken) {
            let response = await fetch(
                window.chaseWPConnect?.loginUrl ||
                    '/wp-json/chase-integration/login-url',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: JSON.stringify({
                        accessToken: accessToken,
                    }),
                },
            );

            url = await response.text();
        }

        let elements = document.querySelectorAll(
            'a[data-enable-chase-oauth-link="true"]',
        );
        elements.forEach(function (el) {
            el.href = url;
        });
    }
});
